/* Open Shopify's existing preferences when arriving from an email footer. */
(() => {
  let timer;
  function openPreferences() {
    clearTimeout(timer);
    if (location.hash !== '#cookie-einstellungen') return;
    let attempts = 0;
    function ready() {
      if (location.hash !== '#cookie-einstellungen') return;
      if (window.privacyBanner?.showPreferences) {
        window.privacyBanner.showPreferences();
      } else if (++attempts < 60) {
        timer = setTimeout(ready, 500);
      }
    }
    ready();
  }
  window.addEventListener('hashchange', openPreferences);
  openPreferences();
})();
